import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import SourceDialogEditing from './sourcedialogediting';
import SourceDialogUI from './sourcedialogui';

export default class SourceDialog extends Plugin {
    /**
	 * @inheritDoc
	 */
    static get requires() {
        return [SourceDialogEditing, SourceDialogUI];
    }

	/**
	 * @inheritDoc
	 */
    static get pluginName() {
        return 'SourceDialog';
    }
}